import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  return {
    needed:
      data.dyn &&
      data.dyn.query &&
      data.dyn.query.fields &&
      !Array.isArray(data.dyn.query.fields),
    logData: {
      msg: 'query.fields had legacy shape',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const {fields} = data.dyn.query;

      const updatedFields = Object.entries(fields)
        .map(([fieldPath, operation]: [any, any]) => {
          // Corrupt operations
          const isCorruptOperation =
            fieldPath === '_draft' || fieldPath === '_archived';

          if (isCorruptOperation) {
            return [];
          }

          // Legacy filters that were simply { fieldPath: value }
          if (typeof operation === 'string') {
            return [
              {
                fieldPath,
                operatorName: 'eq',
                value: operation,
              },
            ];
          }

          // Normal legacy filters that are { fieldPath: { operatorName: value } }
          if (
            typeof operation === 'object' &&
            operation !== null &&
            operation !== undefined
          ) {
            return Object.entries(operation).map(
              ([operatorName, value]: [any, any]) => ({
                fieldPath,
                operatorName,
                value,
              })
            );
          }

          // Satisfies Flow types in case none of the if blocks are reached
          return [];
        })
        .reduce<Array<any>>((acc, cur) => [...acc, ...cur], []);

      data.dyn.query.fields = updatedFields;

      // If the updated `fields` value is an empty array, remove the property
      if (data.dyn.query.fields.length === 0) {
        // eslint-disable-next-line webflow/no-delete
        delete data.dyn.query.fields;

        // Consequently, if removing `fields` results in an empty `query` object
        // let's remove that as well
        if (Object.keys(data.dyn.query).length === 0) {
          // eslint-disable-next-line webflow/no-delete
          delete data.dyn.query;
        }
      }
    },
  };
};
